import type {
  GetAlertSeverityAdAlertFragment,
  GetAlertSeverityTaskNotificationFragment,
} from '@backoffice-frontend/alerts-common'
import { getAlertSeverity } from '@backoffice-frontend/alerts-common'
import type { Theme } from '@emotion/react'

type GetAlertSeverityAlert =
  | GetAlertSeverityTaskNotificationFragment
  | GetAlertSeverityAdAlertFragment

export const getForegroundTextColor = (
  alert: GetAlertSeverityAlert,
  theme: Theme,
): string => {
  switch (getAlertSeverity(alert)) {
    case 'Highest':
      return theme.semantic.ColorCriticalContrast
    case 'High':
      return theme.semantic.ColorWarningContrast
    case 'Normal':
      return theme.semantic.ColorContentDefault
  }
}

export const getDisabledForegroundColor = (
  alert: GetAlertSeverityAlert,
  theme: Theme,
): string => {
  switch (getAlertSeverity(alert)) {
    case 'Highest':
      return theme.semantic.ColorBorderOnCriticalDefault
    case 'High':
      return theme.semantic.ColorWarningPressed
    case 'Normal':
      return theme.semantic.ColorContentReduced
  }
}

export const getBorderColor = (
  alert: GetAlertSeverityAlert,
  theme: Theme,
): string => {
  switch (getAlertSeverity(alert)) {
    case 'Highest':
      return theme.semantic.ColorCriticalDefault
    case 'High':
      return theme.semantic.ColorWarningDefault
    case 'Normal':
      return theme.semantic.ColorBorderOnActionSecondaryDefault
  }
}

export const getBackgroundColor = (
  alert: GetAlertSeverityAlert,
  theme: Theme,
): string => {
  switch (getAlertSeverity(alert)) {
    case 'Highest':
      return theme.semantic.ColorCriticalAlternative
    case 'High':
      return theme.semantic.ColorWarningAlternative
    case 'Normal':
      return theme.semantic.ColorSurfaceReducedAlternative
  }
}
